import React, { ReactNode, useState } from 'react';
import { Container } from 'react-bootstrap';
import LayoutSidebar from 'components/navbars/layout-sidebar/LayoutSidebar';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import Footer from 'components/footers/Footer';
import { useAppContext } from 'providers/AppProvider';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useTranslation } from 'react-i18next';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { t } = useTranslation();
  const {
    config: { isNavbarVerticalCollapsed },
  } = useAppContext();
  
  const { breakpoints } = useBreakpoints();
  const isMobile = breakpoints.down('lg');
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  const handleToggleMobileSidebar = () => {
    setShowMobileSidebar(!showMobileSidebar);
  };

  const handleHideMobileSidebar = () => {
    setShowMobileSidebar(false);
  };

  // Calculate margin for main content
  const getMainContentMargin = () => {
    if (isMobile) return '0';
    if (isNavbarVerticalCollapsed) return '4rem'; // 64px
    return '15.875rem'; // 254px - full sidebar width
  };

  return (
    <div className="layout">
      {/* Sidebar - luôn render nhưng ẩn trên mobile */}
      <LayoutSidebar 
        show={isMobile ? showMobileSidebar : true}
        onHide={handleHideMobileSidebar}
      />
      <NavbarTopDefault onToggleSidebar={handleToggleMobileSidebar} />
      
      <div
        className="main-content"
        style={{
          marginLeft: getMainContentMargin(),
          transition: 'margin-left 0.2s ease',
          minHeight: '100vh',
          paddingTop: '60px', // navbar-top height
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Container fluid className="px-4 py-3 flex-grow-1">
          {children}
        </Container>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
